stimulusApp.register(
  "sort-by",
  class extends Stimulus.Controller {
    static targets = ["trigger", "triggerLabel", "menu"]
    static values = { opened: Boolean }

    toggle() {
      this.openedValue = !this.openedValue
    }

    select({ currentTarget, params }) {
      this.openedValue = false
      this.triggerLabelTarget.textContent = params.triggerLabel
      this.triggerTarget.classList.toggle(
        "sort-by--trigger_applied",
        !params.default,
      )
      this.menuTarget.querySelectorAll(".sort-by--option").forEach((option) => {
        const selected = option === currentTarget
        option.classList.toggle("sort-by--option_selected", selected)
        if (selected) {
          option.setAttribute("aria-current", "true")
        } else {
          option.removeAttribute("aria-current")
        }
      })
    }

    closeOnOutsideClick(event) {
      if (!this.openedValue || this.element.contains(event.target)) return

      this.openedValue = false
    }

    openedValueChanged(opened, wasOpened) {
      this.menuTarget.classList.toggle("sort-by--menu_opened", opened)
      this.triggerTarget.setAttribute("aria-expanded", opened)
      if (
        wasOpened &&
        !opened &&
        this.menuTarget.contains(document.activeElement)
      ) {
        this.triggerTarget.focus()
      }
    }
  },
)
